import { useRoute } from "wouter";
import NotFound from "@/pages/not-found";
import { IndustryPage } from "@/components/IndustryPage";
import { getIndustry } from "@/lib/industries";

export default function IndustryRoute() {
  const [, params] = useRoute("/industries/:slug");
  const slug = params?.slug ?? "";
  const industry = getIndustry(slug);
  if (!industry) return <NotFound />;
  return <IndustryPage industry={industry} path={`/industries/${industry.slug}`} />;
}
